<div class="row">
  <h1 class="col h1-responsive">Checkout Cart
    <input *ngIf="!isSingleOrder" type="button" class="btn btn-secondary" value="Return to Shop" 
    [disabled]="inCheckoutProcess"  [routerLink]="['../']" />
    <input *ngIf="isSingleOrder" type="button" class="btn btn-secondary" 
    [disabled]="inCheckoutProcess" value="Cancel Order" (click)="cancelSingleCheckoutOrder()" />
  </h1>
</div>
<div class="row" *ngIf="items.length === 0">
  <p class="col alert alert-info">Your checkout cart is currently empty</p>
</div>
<table class="table table-striped" *ngIf="items.length">
  <thead class="primary-color white-text">
    <th class="w-50">Items</th>
    <th>Price</th>
    <th>Quantity</th>
    <th>Total</th>
  </thead>
  <tbody>
    <tr *ngFor="let item of items">
      <td> {{item.name}}
        <ul *ngIf="item.subItems?.length">
          <li *ngFor="let subItem of item.subItems">{{subItem.name}}</li>
        </ul>
      </td>
      <td>${{item.price | number:'1.2-2' }}</td>
      <td>
        <input class="form-control" type="number" [(ngModel)]="item.quantity" min="1" />
      </td>
      <td> ${{item.totalPrice | number:'1.2-2'}}
        <button type="button" class="btn btn-secondary btn-sm" aria-label="Delete" (click)="removeItem(item)">
          <span class="fa fa-trash" aria-hidden="true"></span>
        </button>
      </td>
    </tr>
    <tr class="secondary-color white-text">
      <td colspan="3">
        <h4 class="h4-responsive">Order Total</h4>
      </td>
      <td>
        <h4 class="h4-responsive">${{orderTotal | number:'1.2-2'}}</h4>
      </td>
    </tr>
    <tr *ngIf="inCheckoutProcess">
      <td colspan="4">
        <app-checkout-status-monitor></app-checkout-status-monitor>
      </td>
    </tr>
    <tr *ngIf="!inCheckoutProcess">
        <td colspan="4" *ngIf="loadingPaymentInformation">
            <div class="alert alert-info">Loading payment methods</div>
        </td>
    </tr>
    <tr *ngIf="!inCheckoutProcess && !loadingPaymentInformation">
      <td colspan="4" *ngIf="shouldShowPaymentInformation()">
        <div *ngIf="BillingCard">
          <input id="savedCard" type="radio" (click)="setCheckoutSavedCard()" [checked]="useSavedCard" />
          <label for="savedCard">Use <dac-billing-card [card]="BillingCard"></dac-billing-card></label>
        </div>
        <div *ngIf="canUpdateBillingProfile()">
          <input id="newCardAdmin" type="radio" (click)="setCheckoutNewCard()" [checked]="!useSavedCard" />
          <label for="newCardAdmin">Use a new card or <a class="btn btn-secondary btn-sm" [routerLink]="['/admin/my-account/billing']">Update your Billing Profile</a></label>
          <p><small>You will enter your card details at checkout</small></p>
        </div>
        <div *ngIf="!canUpdateBillingProfile()">
          <input id="newCard" type="radio" (click)="setCheckoutNewCard()" [checked]="!useSavedCard" />
          <label for="newCard" *ngIf="!canUpdateBillingProfile()">Use a new card</label>
          <p class="pl-5"><small>You will enter your card details at checkout</small></p>
        </div>
      </td>
      <tr *ngIf="!inCheckoutProcess">
        <td colspan="3">
          <input *ngIf="!isSingleOrder" type="button" class="btn btn-secondary" value="Return to Shop" [routerLink]="['../']" />
          <input *ngIf="isSingleOrder" type="button" class="btn btn-secondary" value="Cancel Order" (click)="cancelSingleCheckoutOrder()" />
        </td>
        <td>
          <input type="button" class="btn btn-primary" (click)="openCheckout()" value="Checkout" [disabled]="loadingPaymentInformation" />
        </td>
      </tr>
  </tbody>
</table>


// WEBPACK FOOTER //
// ./src/app/admin/checkout/checkout.component.html